import { useIsoLayoutEffect } from "shared/lib/react/useIsoLayoutEffect"

import { PageComponentProps, connect, navigateTo } from "scrivito"
import { ProductGroupAttributes } from "scrivito/Objs/ProductGroup/ProductGroupObjClass"

export function ProductGroupPageComponent({
  page
}: PageComponentProps<ProductGroupAttributes>) {
  const parent = page.parent()
  const contentId = page.contentId()

  useIsoLayoutEffect(() => {
    if (parent) {
      navigateTo(parent, { params: { productGroups: contentId } })
    }
  }, [parent])

  return null
}

export const ProductGroupPage = connect(ProductGroupPageComponent)
